<div
    class="tw-flex tw-h-[388px] tw-bg-[#0A0A75] tw-text-white md:tw-items-center tw-px-[25px] md:tw-px-[30px] xl:tw-px-0 tw-gap-10 tw-relative tw-pt-8 md:tw-py-4 tw-pb-0 md:tw-h-[285px] xl:tw-h-[365px]"
>
    <div
        class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-[30px] md:tw-justify-between tw-max-w-[1280px] tw-w-full tw-mx-auto"
    >
        <!-- Left Content -->
        <div
            class="tw-text-center tw-max-w-[320px] tw-mx-auto sm:tw-mx-0 sm:tw-text-left tw-relative tw-z-10 lg:tw-max-w-[500px]"
        >
            <p
                class="tw-w-full tw-text-[26px] md:tw-text-[38px] tw-text-white tw-font-bold tw-leading-[100%] lg:tw-leading-[47px]"
            >
                {{ "INSURANCE_PAGE.POLICY_STREET.SME_PROTECT" | translate }}
            </p>
            <p
                class="!tw-text-[13px] md:!tw-text-[14px] !tw-mt-8 !tw-mb-6 tw-font-normal tw-leading-[141%] lg:tw-leading-[22px] tw-text-center sm:tw-text-left"
            >
                {{ "INSURANCE_PAGE.POLICY_STREET.GET_YOUR_BEST" | translate }}
                <br class="sm:tw-hidden" />
                {{
                    "INSURANCE_PAGE.POLICY_STREET.EMPLOYEE_PROTECTION_PLANS"
                        | translate
                }}
            </p>
        </div>

        <!-- Right Content -->
        <div
            class="tw-w-[240px] md:tw-w-[300px] lg:tw-w-[550px] tw-mt-0 tw-relative"
        >
            <svg
                class="tw-top-[-51px] tw-left-[-38px] tw-absolute md:tw-block tw-hidden"
                width="100"
                height="100"
                viewBox="0 0 128 128"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <ellipse
                    cx="64"
                    cy="64"
                    rx="64"
                    ry="64"
                    transform="rotate(90 64 64)"
                    fill="white"
                    fill-opacity="0.5"
                />
            </svg>

            <!-- Desktop Image -->
            <img
                src="/assets/images/insurance/policy-street-banner.png"
                alt="Digital services"
                class="tw-w-[350px] xl:tw-w-[550px] tw-h-auto tw-hidden md:tw-block md:tw-self-end md:tw-h-full md:tw-object-contain md:tw-object-bottom"
            />

            <!-- Mobile Image -->
            <img
                src="/assets/images/insurance/policy-street-banner-mobile.png"
                alt="Digital services"
                class="tw-w-[140px] tw-h-[115px] tw-block tw-mx-auto md:tw-hidden tw-self-end tw-object-contain tw-object-bottom"
            />
        </div>
    </div>
</div>
